import { render, staticRenderFns } from "./RecruitmentContactRegister.vue?vue&type=template&id=81d95e62&scoped=true&lang=pug"
import script from "./RecruitmentContactRegister.vue?vue&type=script&lang=ts"
export * from "./RecruitmentContactRegister.vue?vue&type=script&lang=ts"
import style0 from "./RecruitmentContactRegister.vue?vue&type=style&index=0&id=81d95e62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d95e62",
  null
  
)

export default component.exports